import React, { useEffect, useState } from "react";
import emailjs from "emailjs-com";
import { Link } from "react-router-dom";
import {
  trackContactUsStart,
  trackContactUsSuccess,
} from "./utils/analytics";

export default function ContactUs({ onClose }) {
  const [form, setForm] = useState({ name: "", phone: "", email: "", message: "", terms: false });
  const [status, setStatus] = useState(null);
  const [contacted, setContacted] = useState(false);

  useEffect(() => {
    trackContactUsStart({ buttonName: "Open form" });
  }, []);

  useEffect(() => {
    if (!contacted) return;
    trackContactUsSuccess({ buttonName: "Send message" });
  }, [contacted]);

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;

    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  console.log(form.terms);
  
  function validateMobileNumber(number) {
    const cleaned = number.replace(/[\s-]/g, "");

    // Regex: starts with 7/8/9 and followed by 9 digits (total 10)
    const regex = /^[6789]\d{9}$/;

    if (!regex.test(cleaned)) {
      return false;
    }
    return true;
  }

  const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);

  const handleSubmit = (e) => {
    if(contacted) return;
    e.preventDefault();
    setStatus(null)
    if (!form.name.trim()) {
      setStatus({ type: "error", msg: "Please enter your name." });
      return;
    }
    if (!validateEmail(form.email)) {
      setStatus({ type: "error", msg: "Please enter a valid email." });
      return;
    }
    if (!validateMobileNumber(form.phone)) {
      setStatus({ type: "error", msg: "Please enter a valid Number." });
      return;
    }
    if (!form.message.trim()) {
      setStatus({ type: "error", msg: "Please enter a message." });
      return;
    }

    emailjs
      .send(
        "service_u7bym51",
        "template_oiyewkv",
        {
          name: form.name,
          title: 'Getting in touch',
          message: `From ${form.email}\n Phone:${form.phone} \nMessage: ${form.message}`,
        },
        "xpSUdxkGNonNPkxCU"
      )
      .then(
        () => {
          trackContactUsSuccess({ buttonName: "Send message" });
          setStatus({ type: "success", msg: "Thank you for contacting us!" });
          setForm({ name: "", phone: "", email: "", message: "", terms: false });
          setContacted(true);
        },
        (error) => {
          console.error("EmailJS Error:", error);
          setStatus({ type: "error", msg: "Something went wrong. Please try again." });
        }
      );
  };

  return (
    <div className="relative w-full min-h-screen flex flex-col pb-4">
      {/* top gradient */}
      <div className="absolute inset-0 pointer-events-none overflow-x-hidden">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {/* gradient 1 */}
          <div className="absolute w-[612.5px] h-[612.5px] top-0 left-[242.5px]
            bg-[radial-gradient(50%_50%_at_50%_50%,rgba(39,196,133,0.24)_0%,rgba(233,242,252,0)_100%)]">
          </div>

          {/* gradient 2 */}
          <div className="absolute w-[612.5px] h-[612.5px] top-[-250px] left-[555px]
            bg-[radial-gradient(50%_50%_at_50%_50%,#EBFCEA_0%,rgba(234,252,236,0)_100%)]">
          </div>

          {/* gradient 3 */}
          <div className="hidden md:block absolute  w-[612.5px] h-[612.5px] top-[600px] left-[195.75px] 
            bg-[radial-gradient(50%_50%_at_50%_50%,#EBFCEA_0%,rgba(234,252,236,0)_100%)]">
          </div>

          {/* gradient 4 */}
          <div className="hidden md:block absolute  w-[612.5px] h-[612.5px] top-[550px] left-[600px] 
            bg-[radial-gradient(50%_50%_at_50%_50%,#E9F2FC_0%,rgba(233,242,252,0)_100%)]">
          </div>
        </div>

      </div>


      <div className="relative z-10 flex-1 w-full flex justify-center px-4 mt-10 pb-10 md:pb-0">

        <form
          className="w-full max-w-[472px] mx-auto mt-10 flex flex-col gap-6 p-6 z-10 bg-white rounded-[24px] border border-[#26C485]"
          onSubmit={handleSubmit}
          noValidate
        >


          {/* Form Description Block */}
          <div className="w-full md:max-w-[424px] md:h-[240px] flex flex-col md:gap-[24px] gap-[16px]">
            <p className="w-full md:max-w-[424px] md:h-[32px] font-nunito font-bold text-[16px] leading-[32px] text-center text-[#656565]">Contact Us</p>
            <p className="w-full md:max-w-[424px] md:h-[128px] font-nunito font-bold md:text-[64px] text-[30px] md:leading-[64px] text-black">Get in touch with us</p>
            <p className="w-full md:w-[374px] md:h-[32px]  font-nunito font-bold md:text-[20px] text-[16px] leading-[30px] md:text-center text-[#656565]">Fill in the form below to reach out to us.</p>
          </div>

          {/* Status Message */}
          {status && (
            <div className={`w-full md:w-[424px] text-center py-2 rounded ${status.type === "error" ? "bg-red-200 text-red-700" : "bg-green-200 text-green-700"}`}>
              {status.msg}
            </div>
          )}

          {/* Fields */}
          <div className="w-full md:max-w-[424px] h-[487px] flex flex-col gap-[8px]">

            {/* Name */}
            <div className="w-full md:max-w-[424px] h-[71px] flex flex-col gap-[4px]">
              <label className="w-full md:max-w-[424px] h-[19px] flex items-center px-[4px]">
                <span className="w-[416px] h-[19px] font-nunito font-semibold text-[14px] leading-[100%] tracking-[-0.41px] text-[#525252]">Name <span className="text-red-500">*</span></span>
              </label>
              <input
                type="text"
                name="name"
                placeholder="Your name"
                value={form.name}
                onChange={handleChange}
                className="w-full md:max-w-[424px] h-[48px] rounded-[16px] border border-[#9E9E9E] px-[16px] bg-[#FBFBFB]"
              />
            </div>

            {/* Email */}
            <div className="w-full md:max-w-[424px] h-[71px] flex flex-col gap-[4px]">
              <label className="w-full md:max-w-[424px] h-[19px] flex items-center px-[4px]">
                <span className="w-[416px] h-[19px] font-nunito font-semibold text-[14px] leading-[100%] tracking-[-0.41px] text-[#525252]">Email <span className="text-red-500">*</span></span>
              </label>
              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                value={form.email}
                onChange={handleChange}
                className="w-full md:max-w-[424px] h-[48px] rounded-[16px] border border-[#9E9E9E] px-[16px] bg-[#FBFBFB]"
              />
            </div>

            {/* Phone */}
            <div className="w-full md:max-w-[424px] h-[71px] flex flex-col gap-[4px]">
              <label className="w-full md:max-w-[424px] h-[19px] flex items-center px-[4px]">
                <span className="w-[416px] h-[19px] font-nunito font-semibold text-[14px] leading-[100%] tracking-[-0.41px] text-[#525252]">Contact number <span className="text-red-500">*</span></span>
              </label>
              <input
                type="tel"
                name="phone"
                placeholder="Enter your contact number"
                value={form.phone}
                onChange={handleChange}
                className="w-full md:max-w-[424px] h-[48px] rounded-[16px] border border-[#9E9E9E] px-[16px] bg-[#FBFBFB]"
              />
            </div>

            {/* Message */}
            <div className="w-full md:max-w-[424px] h-[128px] flex flex-col gap-[4px]">
              <label className="w-full md:max-w-[424px] h-[19px] flex items-center px-[4px]">
                <span className="w-[416px] h-[19px] font-nunito font-semibold text-[14px] leading-[100%] tracking-[-0.41px] text-[#525252]">Message <span className="text-red-500">*</span></span>
              </label>
              <textarea
                name="message"
                placeholder="Enter your message"
                value={form.message}
                onChange={handleChange}
                rows="4"
                maxLength={1000}
                className="w-full md:max-w-[424px] h-[128px] rounded-[16px] border border-[#9E9E9E] py-[8px] px-[16px] bg-[#FBFBFB]"
              />
            </div>

            {/* Terms */}
            <div className="flex items-center gap-2">
              <input
                type="checkbox"
                name="terms"
                checked={form.terms}
                onChange={handleChange}
                className="custom-checkbox"
                style={{ backgroundImage: "url('/checkedIcon.png')" }}
              />
              <p className="font-nunito font-medium text-[14px] leading-tight text-[#525252]">
                I agree to the <Link to="/terms" className="text-[#2C2C2C] font-bold hover:underline">Terms and Conditions</Link>
              </p>
            </div>


            {/* Submit Button */}
            <button
              disabled={contacted || !form.terms}
              type="submit"
              data-analytics-lead-submit
              className={`w-full md:max-w-[424px] h-[48px] rounded-[16px] ${!form.terms ? "bg-gray-300 cursor-not-allowed" : "bg-black"} border border-black flex justify-center items-center px-[12px] mt-[16px] pr-[16px]`}
            >
              <span className="w-[88px] h-[19px] font-nunito font-medium text-[14px] leading-[100%] tracking-[-0.41px] text-white">{contacted ? 'Sent' : 'Send message'}</span>
            </button>

          </div>
        </form>
      </div>
    </div>
  );
}
